import api from './api';

class MaintenanceService {
  // Get all maintenance records with pagination and filtering
  static async getMaintenanceRecords(params = {}) {
    try {
      const response = await api.get('/maintenance', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance records:', error);
      throw error;
    }
  }

  // Get maintenance statistics
  static async getMaintenanceStats() {
    try {
      const response = await api.get('/maintenance/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance statistics:', error);
      throw error;
    }
  }

  // Get maintenance schedule (calendar view)
  static async getMaintenanceSchedule(startDate, endDate) {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      
      const response = await api.get('/maintenance/schedule', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance schedule:', error);
      throw error;
    }
  }

  // Get single maintenance record
  static async getMaintenanceById(id) {
    try {
      const response = await api.get(`/maintenance/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance record:', error);
      throw error;
    }
  }

  // Create new maintenance record
  static async createMaintenance(maintenanceData) {
    try {
      console.log('Creating maintenance record with data:', maintenanceData);
      const response = await api.post('/maintenance', maintenanceData);
      return response.data;
    } catch (error) {
      console.error('Error creating maintenance record:', error);
      console.error('Error response data:', error.response?.data);
      console.error('Error response status:', error.response?.status);
      throw error;
    }
  }

  // Update maintenance record
  static async updateMaintenance(id, maintenanceData) {
    try {
      const response = await api.put(`/maintenance/${id}`, maintenanceData);
      return response.data;
    } catch (error) {
      console.error('Error updating maintenance record:', error);
      throw error;
    }
  }

  // Delete maintenance record
  static async deleteMaintenance(id) {
    try {
      const response = await api.delete(`/maintenance/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting maintenance record:', error);
      throw error;
    }
  }

  // Search maintenance records
  static async searchMaintenance(searchTerm, filters = {}) {
    try {
      const params = {
        search: searchTerm,
        ...filters
      };
      const response = await api.get('/maintenance', { params });
      return response.data;
    } catch (error) {
      console.error('Error searching maintenance records:', error);
      throw error;
    }
  }

  // Get maintenance by asset
  static async getMaintenanceByAsset(assetId) {
    try {
      const response = await api.get('/maintenance', { 
        params: { assetId } 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance by asset:', error);
      throw error;
    }
  }

  // Get maintenance by technician
  static async getMaintenanceByTechnician(technicianName) {
    try {
      const response = await api.get('/maintenance', { 
        params: { technician: technicianName } 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance by technician:', error);
      throw error;
    }
  }

  // Get maintenance by date range
  static async getMaintenanceByDateRange(startDate, endDate) {
    try {
      const response = await api.get('/maintenance', { 
        params: { startDate, endDate } 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching maintenance by date range:', error);
      throw error;
    }
  }

  // Get upcoming maintenance
  static async getUpcomingMaintenance(days = 30) {
    try {
      const startDate = new Date();
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + days);
      
      const response = await api.get('/maintenance', { 
        params: { 
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          status: 'Scheduled'
        } 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching upcoming maintenance:', error);
      throw error;
    }
  }

  // Get overdue maintenance
  static async getOverdueMaintenance() {
    try {
      const today = new Date();
      const response = await api.get('/maintenance', { 
        params: { 
          endDate: today.toISOString(),
          status: 'Scheduled'
        } 
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching overdue maintenance:', error);
      throw error;
    }
  }
}

export default MaintenanceService;
